export default "__VITE_ASSET__BDM_FiuH__"